import PageWrapper from '../components/PageWrapper';
import { PAGE_CTAS } from '../components/marketing/pageCtas';
import MarketingHero from '../components/marketing/MarketingHero';
import MarketingSection from '../components/marketing/MarketingSection';
import FeaturedArticle from '../components/marketing/FeaturedArticle';
import BlogCard from '../components/marketing/BlogCard';
import FadeIn from '../components/marketing/FadeIn';
import { featuredPost, gridPosts } from '../data/blogPosts';

export default function BlogPage() {
  return (
    <PageWrapper cta={PAGE_CTAS.blog}>
      <MarketingHero
        eyebrow="Stavyn Journal"
        title="Insights on talent, retention,"
        accent="and the future of work."
        accentBlock
        subtitle="Research, analysis, and strategies for building teams that stay."
      />

      {featuredPost && (
        <MarketingSection padding="none" maxWidth="5xl" className="marketing-section--after-hero">
          <FeaturedArticle post={featuredPost} />
        </MarketingSection>
      )}

      <MarketingSection padding="lg" maxWidth="5xl">
        <FadeIn delay={0.1}>
          <div className="section-tag marketing-section-label">All Articles</div>
        </FadeIn>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {gridPosts.map((post, i) => (
            <BlogCard key={post.slug} post={post} delay={0.08 + i * 0.07} />
          ))}
        </div>
      </MarketingSection>
    </PageWrapper>
  );
}
